"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fields = exports.FieldArray = exports.Field = exports.useIsFinalForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _reduxForm = require("redux-form");

var useIsFinalForm = function useIsFinalForm() {
  try {
    // If this returns without throwing, it's a Final Form.
    (0, _reactFinalForm.useForm)();
    return true;
  } catch (_unused) {
    return false;
  }
};

exports.useIsFinalForm = useIsFinalForm;

var Field = function Field(props) {
  var isFinalForm = useIsFinalForm();

  if (isFinalForm) {
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, props);
  }

  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, props);
};

exports.Field = Field;

var FieldArray = function FieldArray(props) {
  var isFinalForm = useIsFinalForm();

  if (isFinalForm) {
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FieldArray, props);
  }

  return /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, props);
};

exports.FieldArray = FieldArray;

var Fields = function Fields(props) {
  var isFinalForm = useIsFinalForm();

  if (isFinalForm) {
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Fields, props);
  }

  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Fields, props);
};

exports.Fields = Fields;